/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestConvexBaseRewardPool extends Contract<ITestConvexBaseRewardPool> {
  extraRewards: Call<(_index: BigNumberish) => string, ITestConvexBaseRewardPool>
  'extraRewards(uint256)': Call<(_index: BigNumberish) => string, ITestConvexBaseRewardPool>
  stakeFor: Send<(_for: AddressLike, _amount: BigNumberish) => boolean, ITestConvexBaseRewardPool>
  'stakeFor(address,uint256)': Send<(_for: AddressLike, _amount: BigNumberish) => boolean, ITestConvexBaseRewardPool>
}

let ITestConvexBaseRewardPoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestConvexBaseRewardPoolBytecode = '0x';
}

// prettier-ignore
export const ITestConvexBaseRewardPool = contract<ITestConvexBaseRewardPool>(ITestConvexBaseRewardPoolBytecode)`
  function extraRewards(uint256 _index) view returns (address rewardToken_)
  function stakeFor(address _for, uint256 _amount) returns (bool success_)
`;